module.exports = __webpack_public_path__ + "media/assets/icons/linkedin-c6ff35deede13613c83debd9ba0fe616.svg";